var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 316.15,
    height: 266,
    viewBox: "0 0 316.15 266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -1.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316.15,
    height: 266,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.63,152.11H1.68v41.33H83.63Z",
    transform: "translate(0 -1.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,143.46H32.53v8.65H52.77Z",
    transform: "translate(0 -1.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.13,191.5H12.47v8.66h8.66Z",
    transform: "translate(0 -1.17)",
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.24,191.59H66.58v8.65h8.66Z",
    transform: "translate(0 -1.17)",
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.64,203.07a7.12,7.12,0,0,0,7.12-7V196h4.89a4.86,4.86,0,0,0,4.89-4.88V155.88A4.86,4.86,0,0,0,82.65,151H55.7v-2.66a5.51,5.51,0,0,0-5.58-5.58H47.61l.42-.42L65.34,125a1.45,1.45,0,0,0,.56-1.12,1.26,1.26,0,0,0-.56-1.11,1.52,1.52,0,0,0-2.1,0l-20,19.68H37.69a5.51,5.51,0,0,0-5.58,5.59v2.65H4.89A4.85,4.85,0,0,0,0,155.6v35.05a4.85,4.85,0,0,0,4.89,4.88H9.77v.14a7,7,0,0,0,7.12,7,7.12,7.12,0,0,0,7.12-7v-.14H63.52v.14A7.21,7.21,0,0,0,70.64,203.07ZM2.93,155.74a1.91,1.91,0,0,1,2-2H15.5v18H3.07V155.74Zm7.68,36.86-5.86.14a1.91,1.91,0,0,1-2-2V174.73H15.08V189h-.14A9,9,0,0,0,10.61,192.6ZM17,199.86A3.91,3.91,0,1,1,20.94,196,4,4,0,0,1,17,199.86Zm12.15-7.26h-6v-.14A7,7,0,0,0,18.57,189h-.14V153.79H29.18ZM35,148.21a2.51,2.51,0,0,1,2.52-2.52H50.12a2.5,2.5,0,0,1,2.51,2.52v2.65H35ZM55.29,192.6H32.11v-18H55.29Zm0-20.94H32.11V153.93H55.29Zm16.89-17.73H82.79a1.9,1.9,0,0,1,1.95,1.95v16.06H72.46v-18Zm0,20.94H84.46v16.06a1.9,1.9,0,0,1-1.95,1.95H76.65v-.14A7,7,0,0,0,72,189.25H71.9V175h.28ZM74.69,196A3.91,3.91,0,1,1,70.78,192,3.82,3.82,0,0,1,74.69,196ZM58.5,192.6V153.93H69.25v35.18h-.14a8.27,8.27,0,0,0-4.61,3.49v.14h-6Z",
    transform: "translate(0 -1.17)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.94,156H20.8v31.7h6.14Z",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.59,156H60.45v31.7h6.14Z",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,59.6a19.92,19.92,0,0,1,14.8-6.4,20.3,20.3,0,0,1,0,40.6,20.63,20.63,0,0,1-14.8-6.4",
    transform: "translate(0 -1.17)",
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,59.6a19.92,19.92,0,0,1,14.8-6.4,20.3,20.3,0,0,1,0,40.6,20.63,20.63,0,0,1-14.8-6.4",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,84.8a18.6,18.6,0,1,0,0-22.6",
    transform: "translate(0 -1.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,84.8a18.6,18.6,0,1,0,0-22.6",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,67h-.6V65.5a3,3,0,0,0-3-3h-4.5l1.7-4h1.6a.5.5,0,0,0,0-1h-9.5a.5.5,0,1,0,0,1h1.6l1.7,4h-4.6a3,3,0,0,0-3,3V67H237a1.32,1.32,0,0,0-1.3,1.3v3.2a.5.5,0,0,0,1,0V68.3a.37.37,0,0,1,.4-.4h.6V83.2a.47.47,0,0,0,.5.5h2.7l-3,3c-.1.1-.2.4-.1.5a.54.54,0,0,0,.4.3h16.9c.2,0,.4-.1.4-.3a.44.44,0,0,0-.1-.5l-1.9-1.9-1.1-1.1h2.7a.47.47,0,0,0,.5-.5V67.9h.6a.37.37,0,0,1,.4.4v3.2a.5.5,0,0,0,1,0V68.3A1.49,1.49,0,0,0,256.2,67Zm-11.7-8.4h4.3l-1.7,4h-.9Zm-6.1,6.9a2,2,0,0,1,2.1-2h12.2a2.09,2.09,0,0,1,2.1,2V67H238.6l-.2-1.5Zm5.1,11.4v-9h6.1v8.9Zm-4.4,9.7,1-1H253l1,1Zm13-1.9h-11l1-1h9.1Zm2.6-1.9H238.5V67.9h4.1v8.9h-2.7a.5.5,0,0,0,0,1h13.4a.5.5,0,0,0,0-1h-2.7V67.9h4.1V82.8Z",
    transform: "translate(0 -1.17)",
    fill: "#71c4ef",
    stroke: "#71c4ef",
    strokeMiterlimit: 10,
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1,65.7a.5.5,0,0,0,0-1h-7a.5.5,0,0,0,0,1Z",
    transform: "translate(0 -1.17)",
    fill: "#71c4ef",
    stroke: "#71c4ef",
    strokeMiterlimit: 10,
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,78.9a1.4,1.4,0,1,0,1.4,1.4A1.43,1.43,0,0,0,246.6,78.9Zm0,1.9a.5.5,0,1,1,.5-.5A.54.54,0,0,1,246.6,80.8Z",
    transform: "translate(0 -1.17)",
    fill: "#71c4ef",
    stroke: "#71c4ef",
    strokeMiterlimit: 10,
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,263.6H100.7a16.79,16.79,0,0,1-16.9-16.8V19.8A16.92,16.92,0,0,1,100.7,3H215.1A16.79,16.79,0,0,1,232,19.8V246.7A17.09,17.09,0,0,1,215,263.6Z",
    transform: "translate(0 -1.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,253.1a6.44,6.44,0,0,1-6.4-6.4V19.8a6.44,6.44,0,0,1,6.4-6.4H215.1a6.44,6.44,0,0,1,6.4,6.4V246.7a6.44,6.44,0,0,1-6.4,6.4Z",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,248a1.26,1.26,0,0,1-1.3-1.3V19.8a1.32,1.32,0,0,1,1.3-1.3H215.1a1.26,1.26,0,0,1,1.3,1.3V246.7a1.32,1.32,0,0,1-1.3,1.3Z",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,37.8h148",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,227.4h148",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,240.9h28.8",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,90.6H133.7a8.26,8.26,0,0,0-8.3,8.2v57.8a7.52,7.52,0,0,0,3.3,6.2v6.1a5.85,5.85,0,0,0,5.9,5.9h1.7a5.85,5.85,0,0,0,5.9-5.9v-3.7h31.5v3.7a5.85,5.85,0,0,0,5.9,5.9h1.7a5.85,5.85,0,0,0,5.9-5.9v-5.5a8.54,8.54,0,0,0,3.3-6.6v-58A8.71,8.71,0,0,0,182,90.6Zm4.5,51.9v14.1a4.53,4.53,0,0,1-4.6,4.6H134.4c-2.4,0-5.3-2-5.3-4.6V142.5Zm-48.2,22.3v3.7a1.89,1.89,0,0,1-2,2h-1.8a1.89,1.89,0,0,1-2-2v-4a8.8,8.8,0,0,0,2,.4h3.8Zm39.1,0H182a3,3,0,0,0,1.3-.2v3.8a1.89,1.89,0,0,1-2,2h-1.7a1.89,1.89,0,0,1-2-2v-3.7h-.2Zm9.1-57.6v31.4H129.3V107.2Zm0-8.4v4.6H129.3V98.8a4.53,4.53,0,0,1,4.6-4.6h48.2A4.84,4.84,0,0,1,186.5,98.8Z",
    transform: "translate(0 -1.17)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,156.1a5.19,5.19,0,0,0,5.1-5.1,5.1,5.1,0,0,0-10.2,0A5.12,5.12,0,0,0,137.8,156.1Zm-1.3-5.2a1.26,1.26,0,0,1,1.3-1.3,1.21,1.21,0,0,1,1.3,1.3,1.32,1.32,0,0,1-1.3,1.3A1.26,1.26,0,0,1,136.5,150.9Z",
    transform: "translate(0 -1.17)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,156.1A5.19,5.19,0,0,0,183,151a5.26,5.26,0,0,0-5.1-5.1,5.19,5.19,0,0,0-5.1,5.1A5.26,5.26,0,0,0,177.9,156.1Zm-1.3-5.2a1.3,1.3,0,1,1,1.3,1.3A1.26,1.26,0,0,1,176.6,150.9Z",
    transform: "translate(0 -1.17)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,88a75.45,75.45,0,0,1,117,0",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,121.9c.2.5.2,1.3.4,1.8a74.26,74.26,0,0,1,.9,11.5c0,2.4-.2,4.9-.4,7.3-.2,2-.6,4.2-.9,6.2",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,182.6a75.45,75.45,0,0,0,117,0",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,122.1c0,.4-.2.9-.2,1.3a4.4,4.4,0,0,0-.2,1.6c-.2,1.5-.4,3.1-.6,4.6a53.34,53.34,0,0,0-.2,5.7,82.31,82.31,0,0,0,1.1,13.3",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,96.8a70.19,70.19,0,0,1,117,.2",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,173.8a70.19,70.19,0,0,0,117,0",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.1,110.5H132.5v24.9h50.6Z",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.1,97H132.5v3.8h50.6Z",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,130H83.5l.4-13.5H57.1",
    transform: "translate(0 -1.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.07
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.33d94b6f.svg";
export { ForwardRef as ReactComponent };